import React, { useState } from "react";
import { ButtonSizeOptions } from "@loanbossinc/component-library";
import {
  RentCodeItemWrapper,
  StyledField,
  StyledButtonText,
  StyledPrimaryButton,
  StyledSecondaryButton,
} from "./styles";

const RentCodeItem = (props) => {
  const {
    index,
    companyId,
    codeAlias,
    codeAliasCount,
    onCodeAliasSave,
    onCodeAliasCancel,
    onCodeAliasDelete,
  } = props;

  const [aliasValue, setAliasValue] = useState(codeAlias.alias);

  const editModeEnabled = !codeAlias.alias || aliasValue !== codeAlias.alias;

  const handleCodeAliasChange = (e) =>
    setAliasValue(e.currentTarget.value.toUpperCase());

  const handleCodeAliasSave = () =>
    onCodeAliasSave({
      companyId,
      index,
      codeAliasId: codeAlias.id,
      codeAliasValue: aliasValue,
    });

  const handleCodeAliasCancel = () => {
    setAliasValue(codeAlias.alias);

    if (onCodeAliasCancel) {
      onCodeAliasCancel({ index });
    }
  };

  const handleCodeAliasDelete = () =>
    onCodeAliasDelete({
      companyId,
      index,
      codeAliasId: codeAlias.id,
    });

  return (
    <RentCodeItemWrapper>
      <StyledField
        name="codeAlias"
        type="text"
        value={aliasValue}
        label="Rent"
        autoComplete="off"
        onChange={handleCodeAliasChange}
        disabled={codeAlias.temporaryCodeAlias || codeAlias.isDefault}
        InputLabelProps={{ shrink: true }}
      />

      {editModeEnabled ? (
        <>
          <StyledPrimaryButton
            label="Save"
            onClick={handleCodeAliasSave}
            disabled={!aliasValue}
            size={ButtonSizeOptions.sm}
            style={{
              marginLeft: "1.25em",
            }}
          />
          <StyledSecondaryButton
            label="Cancel"
            onClick={handleCodeAliasCancel}
            size={ButtonSizeOptions.sm}
            style={{
              marginLeft: "1.25em",
            }}
          />
        </>
      ) : (
        <StyledButtonText
          label="Delete"
          iconName="delete_outline"
          disabled={codeAlias.temporaryCodeAlias || codeAliasCount === 1}
          onClick={handleCodeAliasDelete}
          style={{
            marginLeft: "1.25em",
          }}
          reverse
        />
      )}
    </RentCodeItemWrapper>
  );
};

export default RentCodeItem;
